import { LoginTemplate } from "../../template/login-template";
import { SuccessBanner } from "@graffer-inc/console-design-kit";
import { parseQueryOfLocation } from "../../../utils/url-utils";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import apiClient from "../../../application/apis/tenant-management/tenant-management-client";
import { reportUnexpectedError } from "../../../error-reporter";
import { CloudGovApiError } from "../../../application/domain/api-error";

export const ResetPasswordPage = () => {
  const { token } = parseQueryOfLocation(useLocation()) as {
    token: string;
  };

  const [error, setError] = useState("");
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    if (!token) {
      setError(
        "不正なURLです。仮パスワード再設定メール内のURLからアクセスしてください。",
      );
      return;
    }

    apiClient
      .resetTmpPassword({ token })
      .then(() => {
        setCompleted(true);
      })
      .catch((e) => {
        if (CloudGovApiError.isErrorCode(e, "invalid_token")) {
          setError(
            "仮パスワードの再設定がすでに完了したか、URLの有効期限切れです。",
          );
          return;
        }
        if (CloudGovApiError.is404(e)) {
          setError("不正なURLです。");
          return;
        }
        setError("予期しないエラーが発生しました。");
        reportUnexpectedError(e);
      });
  }, []);

  return (
    <LoginTemplate>
      {completed && (
        <SuccessBanner
          message="仮パスワードの再設定が完了しました。アカウントに設定されているメールアドレスに仮パスワードを送信しました。"
          description=""
        />
      )}
      {!!error && (
        <div className="notification is-danger is-light">{error}</div>
      )}
    </LoginTemplate>
  );
};
